<script>
    import {createEventDispatcher, onMount, onDestroy} from "svelte";
    const dispatch = createEventDispatcher();
    import {closeSearchPanel, closeAllergensFilterPanel, screensStore, toggleAllergensFilterPanel, toggleSearchPanel} from "../core/screens-manager.js";
    import {filterFavorites, filtersStore, resetFilterFavorites} from "../core/app-store.js";
    import { t } from '../core/i18n/language-store';
    import { scrollToElementId } from "../core/utils.js";
    
    export let items = [];
    export let favorites = [];

    let collapsedBurger = true;
    
    function scrollToSection (id) {
        dispatch('scrollToSection', {id});
    }
    
    function filterFavoritesHandler() {
        filterFavorites();
        closeSearchPanel();
        closeAllergensFilterPanel();
    }

    function toggleSearchPanelHandler() {
        toggleSearchPanel();
        closeAllergensFilterPanel();
        resetFilterFavorites();
    }

    function toggleAllergensFilterPanelHandler() {
        toggleAllergensFilterPanel();
        closeSearchPanel();
        resetFilterFavorites();
    }
    

    $: filteredItems = items.filter(item => item.sectionType !== 'text-block');

    let observer;
    let currentActiveSection = null;

    function toggleBurgerHandler() {
        collapsedBurger = !collapsedBurger;

        if (collapsedBurger) {
            closeSearchPanel();
            closeAllergensFilterPanel();
            resetFilterFavorites();
        }       
    }

    function isElementVisible(elementId) {
        const element = document.getElementById(elementId);
        if (!element) return false;

        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        // console.log('>>> ', elementId, rect.top, windowHeight + window.scrollY, rect.bottom, rect.top >= 0 && rect.bottom <= windowHeight);

        return rect.top >= 0 && rect.bottom > windowHeight;
    }

    function updateActiveSection(entries) {
        let maxVisibility = 0;
        let mostVisibleSection = null;

        // filteredItems.forEach(item => {
        //     console.log('>>> ', item.id, isElementVisible(item.id));
        // });

        entries.forEach(entry => {


            // console.log('>>> ', entry.target.id, entry.target.getBoundingClientRect().top);


            // Calculate % of visibility of section
            const visibilityRatio = entry.intersectionRatio;
            
            // console.log('>>> id', entry.target.id, visibilityRatio);

            if (visibilityRatio > (maxVisibility * 1) ) {
                maxVisibility = visibilityRatio;
                mostVisibleSection = entry.target.id;
            }
        });


        // filteredItems.forEach(item => {
        //     const element = document.getElementById(item.id);
        //     if (element.id === mostVisibleSection) {
        //         element.style.backgroundColor = 'lime';
        //     }
        //     else {
        //         element.style.backgroundColor = 'red';
        //     }
        // }); 

        if (mostVisibleSection) {
            currentActiveSection = mostVisibleSection;

            items = items.map(item => ({
                ...item,
                isActive: item.id === currentActiveSection
            }));

            scrollActiveItemToCenter();
        }
    }

    function scrollActiveItemToCenter() {
        const nav = document.querySelector('.nav');
        const activeItem = nav?.querySelector('.nav-item.active');
        
        if (nav && activeItem) {
            
            const navRect = nav.getBoundingClientRect();
            const activeItemRect = activeItem.getBoundingClientRect();
            const scrollLeft = activeItemRect.left - navRect.left - (navRect.width / 2) + (activeItemRect.width / 2);
            
            nav.scrollTo({
                left: nav.scrollLeft + scrollLeft,
                behavior: 'smooth'
            });
        }
    }

    onMount(() => {
        // Create observer with 0.1 threshold (10% of visibility)
        observer = new IntersectionObserver(updateActiveSection, {
            //threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
            rootMargin: "-20% 0px -20% 0px" // Ignore 20% of screen top/bottom
        });

        // observe sections
        filteredItems.forEach(item => {
            const element = document.getElementById(item.id);
            if (element) {
                observer.observe(element);
                // element.style.border = '5px dashed red'; 
            }
        });
    });

    onDestroy(() => {
        if (observer) {
            observer.disconnect();
        }
    });
</script>

<style>
    .nav {
        display: flex;
        align-items: center;
        gap: 0;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .nav::-webkit-scrollbar {
        display: none;
    }

    .nav-item {
        font-family: Roboto Condensed, sans-serif;
        font-size: 16px;
        font-weight: 800;
        text-transform: uppercase;
        padding: 0.75rem 1rem;
        
        white-space: nowrap;
        position: relative;
        border: none;

        display: flex;
        align-items: center;
        gap: 0.5em;

        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;

        transition: all 0.3s ease;
    }

    .nav-item:not(.active) {
        background-color: var(--main-font-color);
        color: var(--bg-color);
    }

    .nav-item.active {
        background-color: var(--bg-color);
        color: var(--accent-color);
        z-index: 2;
        border-bottom-color: var(--accent-color);
    }
    
    .nav-item-group {
        display: flex;
        align-items: center;
        gap: 0;
    }
    .nav-item-group--collapsed {
        width: 0;
        overflow: hidden;
    }   
    .nav-item-group--divider {
        width: 1px;
        height: 1.5em;
        background-color: var(--bg-color);
        margin: 0 1em 0;
        opacity: .5;
    }

    @media (min-width: 768px) {
        .nav-item {
            cursor: pointer;
        }
        .nav-item:hover:not(.active) {
            border-bottom-color: var(--bg-color);
        }
        .nav-item.nav-item--burger:hover:not(.active) {
            border-bottom-color: transparent;
            color: var(--accent-color-semi);
        }
    }
</style>

<nav class="nav">

    <button class="nav-item nav-item--burger user-select-none" on:click={toggleBurgerHandler}>
        {#if collapsedBurger}
            <svg width="1em" height="1em" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.9751 1.47498H17.9751M1.9751 7.47498H17.9751M1.9751 13.475H17.9751" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>       
        {/if} 
        {#if !collapsedBurger}
            <svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.9998 8.90005L2.0998 13.8C1.91647 13.9834 1.68314 14.075 1.3998 14.075C1.11647 14.075 0.883138 13.9834 0.699804 13.8C0.516471 13.6167 0.424805 13.3834 0.424805 13.1C0.424805 12.8167 0.516471 12.5834 0.699804 12.4L5.5998 7.50005L0.699804 2.60005C0.516471 2.41672 0.424805 2.18338 0.424805 1.90005C0.424805 1.61672 0.516471 1.38338 0.699804 1.20005C0.883138 1.01672 1.11647 0.925049 1.3998 0.925049C1.68314 0.925049 1.91647 1.01672 2.0998 1.20005L6.9998 6.10005L11.8998 1.20005C12.0831 1.01672 12.3165 0.925049 12.5998 0.925049C12.8831 0.925049 13.1165 1.01672 13.2998 1.20005C13.4831 1.38338 13.5748 1.61672 13.5748 1.90005C13.5748 2.18338 13.4831 2.41672 13.2998 2.60005L8.3998 7.50005L13.2998 12.4C13.4831 12.5834 13.5748 12.8167 13.5748 13.1C13.5748 13.3834 13.4831 13.6167 13.2998 13.8C13.1165 13.9834 12.8831 14.075 12.5998 14.075C12.3165 14.075 12.0831 13.9834 11.8998 13.8L6.9998 8.90005Z" fill="black"/>
            </svg>          
        {/if}
    </button>
    
    <div class="nav-item-group" class:nav-item-group--collapsed={collapsedBurger}>
        
        {#if (favorites?.length > 0)}
            <button class="nav-item user-select-none" class:active={$filtersStore.favorites} on:click={filterFavoritesHandler}>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Heart"><path d="M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 0 0 1.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"/></svg>
                { $t('nav.favorite') } ({ favorites.length })
            </button>
        {/if}

        <button class="nav-item user-select-none" class:active={$screensStore.searchPanelOpened} on:click={toggleSearchPanelHandler}>
            <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 2.49999C5.67392 2.49999 4.40215 3.02677 3.46447 3.96446C2.52678 4.90214 2 6.17391 2 7.49999C2 8.82607 2.52678 10.0978 3.46447 11.0355C4.40215 11.9732 5.67392 12.5 7 12.5C8.32608 12.5 9.59785 11.9732 10.5355 11.0355C11.4732 10.0978 12 8.82607 12 7.49999C12 6.17391 11.4732 4.90214 10.5355 3.96446C9.59785 3.02677 8.32608 2.49999 7 2.49999ZM2.20582e-07 7.49999C2.1098e-06 6.39125 0.263375 5.29837 0.768432 4.31134C1.27349 3.32431 2.00578 2.47138 2.90501 1.82276C3.80423 1.17415 4.84467 0.74842 5.94064 0.580626C7.03661 0.412832 8.15676 0.507776 9.20885 0.857639C10.2609 1.2075 11.2149 1.80228 11.9921 2.59298C12.7693 3.38369 13.3476 4.34771 13.6794 5.40567C14.0111 6.46362 14.0868 7.58524 13.9001 8.67816C13.7135 9.77108 13.27 10.804 12.606 11.692L15.707 14.792L14.293 16.207L11.193 13.107C10.1525 13.8853 8.91592 14.3587 7.62167 14.4741C6.32741 14.5895 5.02658 14.3424 3.86481 13.7604C2.70304 13.1784 1.72618 12.2846 1.0436 11.1789C0.361027 10.0732 -0.000325925 8.79938 2.20582e-07 7.49999Z" fill="currentColor"/></svg>
            { $t('nav.search') }
        </button>

        <button class="nav-item user-select-none" class:active={$screensStore.filtersOpened} on:click={toggleAllergensFilterPanelHandler}>
            <svg width="1em" height="1.2em" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00013 18.6666C5.60846 18.6666 5.22513 18.625 4.84179 18.5416C1.91679 17.9166 0.0584609 15.0333 0.683461 12.1083C0.891794 11.125 1.37513 10.225 2.06679 9.49996C2.20336 9.35597 2.27949 9.16508 2.27949 8.96663C2.27949 8.76817 2.20336 8.57728 2.06679 8.43329C0.333461 6.28329 0.666795 3.13329 2.81679 1.39996C4.96679 -0.333374 8.11679 0.00579237 9.85013 2.15829C11.3251 3.98329 11.3251 6.58329 9.85013 8.43329C9.60846 8.77496 9.64179 9.24996 9.93346 9.54996C11.9751 11.7333 11.8668 15.1666 9.67513 17.2083C8.68036 18.1444 7.36608 18.6659 6.00013 18.6666ZM6.00013 1.99996C5.24179 1.99996 4.50013 2.25829 3.91679 2.74163C3.57488 3.01393 3.29017 3.35114 3.07902 3.73385C2.86787 4.11657 2.73445 4.53725 2.68644 4.9717C2.63842 5.40615 2.67676 5.84581 2.79924 6.2654C2.92172 6.68499 3.12593 7.07623 3.40013 7.41663C4.20013 8.36663 4.14179 9.77496 3.27513 10.675C1.85846 12.1833 1.94179 14.5583 3.45013 15.975C4.95846 17.3916 7.33346 17.3166 8.75013 15.8C9.40042 15.1052 9.76223 14.1891 9.76223 13.2375C9.76223 12.2858 9.40042 11.3698 8.75013 10.675C8.31903 10.2353 8.06533 9.65208 8.03765 9.03698C8.00997 8.42188 8.21026 7.8182 8.60013 7.34163C9.15224 6.6519 9.40795 5.77119 9.31108 4.89303C9.2142 4.01486 8.77265 3.21108 8.08346 2.65829C7.66679 2.34163 7.22513 2.11663 6.73346 1.99996H6.00013ZM6.00013 4.49996C6.00013 4.95829 6.37513 5.33329 6.83346 5.33329C7.29179 5.33329 7.66679 4.95829 7.66679 4.49996C7.66679 4.04163 7.29179 3.66663 6.83346 3.66663C6.37513 3.66663 6.00013 4.04163 6.00013 4.49996ZM7.66679 15.3333C8.12513 15.3333 8.50013 14.9583 8.50013 14.5C8.50013 14.0416 8.12513 13.6666 7.66679 13.6666C7.20846 13.6666 6.83346 14.0416 6.83346 14.5C6.83346 14.9583 7.20846 15.3333 7.66679 15.3333ZM6.83346 12.8333C7.29179 12.8333 7.66679 12.4583 7.66679 12C7.66679 11.5416 7.29179 11.1666 6.83346 11.1666C6.37513 11.1666 6.00013 11.5416 6.00013 12C6.00013 12.4583 6.37513 12.8333 6.83346 12.8333ZM5.16679 14.5C5.62513 14.5 6.00013 14.125 6.00013 13.6666C6.00013 13.2083 5.62513 12.8333 5.16679 12.8333C4.70846 12.8333 4.33346 13.2083 4.33346 13.6666C4.33346 14.125 4.70846 14.5 5.16679 14.5Z" fill="currentColor"/></svg>
            { $t('nav.allergens') }
        </button>

        <div class="nav-item-group--divider"></div>
    </div>


    {#each filteredItems as item (item.id)}
        <button
            class="nav-item user-select-none"
            class:active={item.isActive}
            on:click={() => scrollToSection(item.id)}>
            {item.title}
        </button>
    {/each}

</nav>
